"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PixelEventType;
(function (PixelEventType) {
    PixelEventType["AddToCart"] = "add_to_cart";
    PixelEventType["CheckoutCustomerInfo"] = "checkout_customer_info";
    PixelEventType["CheckoutInit"] = "checkout_init";
    PixelEventType["CheckoutPayment"] = "checkout_payment";
    PixelEventType["CheckoutPaymentSubmitted"] = "checkout_payment_submitted";
    PixelEventType["CheckoutShipping"] = "checkout_shipping";
    PixelEventType["CheckoutConfirmation"] = "checkout_confirmation";
    PixelEventType["CheckoutStep"] = "checkout_step";
    PixelEventType["CheckoutPaymentOptionChanged"] = "checkout_payment_option_changed";
    PixelEventType["CheckoutShippingOptionChanged"] = "checkout_shipping_option_changed";
    PixelEventType["GoogleCustomEvent"] = "google_custom_event";
    PixelEventType["PageView"] = "page_view";
    PixelEventType["Purchase"] = "purchase";
    PixelEventType["RemoveFromCart"] = "remove_from_cart";
    PixelEventType["Transaction"] = "transaction";
})(PixelEventType = exports.PixelEventType || (exports.PixelEventType = {}));



//////////////////
// WEBPACK FOOTER
// ./~/@flowio/pixel/dist/types.js
// module id = 111
// module chunks = 0 1